import { AccountSwitchIcon } from './AccountSwitchIcon';

/**
 * author: Austin Andrews
 * id FC4F4C4D-83C2-493F-9606-CA80E44BFEF8
 * name account-switch
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-switch.svg
 * tags
 * - Account / User 
 */
export const PersonSwitchIcon = AccountSwitchIcon;
export default PersonSwitchIcon